import { FC } from 'react';
import style from './serviceTopCardStyle.module.css';
import { UserActionCategory } from '@/types/api/serviceApi';

interface ServiceTopCardProps {
  userActionCategories?: UserActionCategory[];
}

export const ServiceTopCard: FC<ServiceTopCardProps> = ({
  userActionCategories,
}) => {
  if (!userActionCategories || userActionCategories.length === 0) {
    return null;
  }

  return (
    <div className={style['top-card-wrapper']}>
      <div className={style['top-card-grid']}>
        {userActionCategories.map((category) => (
          <div key={category.id} className={style['top-card-item']}>
            <div className={style['icon-wrapper']}>
              <i className={category.icon_class} />
            </div>
            <div className={style['category-name']}>{category.name}</div>
            {category.description && (
              <div className={style['category-description']}>
                {category.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
